import { SurveyQuestion } from "./survey-question";

export class SurveyAnswer{
    answer: string;
    id: number;
    surveyAttemptId: number;
    surveyQuestionId: number;
    comment?: string;
    surveyQuestion:SurveyQuestion;
}